import type { ProductColor } from '@aloft/toolkit-shared';
import { Icon } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-box, aloft/prefer-sound-ui-button
import { Box, Button } from '@aloft/toolkit-sui/chakra';

import type { PropsWithChildren } from 'react';

type PropertyPinIconProps = {
  propertyId?: string;
  color: ProductColor;
  text?: string;
  subjectAsPin?: boolean;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
};

const Wrapper = ({
  children,
  onClick,
}: PropsWithChildren<Pick<PropertyPinIconProps, 'onClick'>>) =>
  onClick ? (
    <Button
      variant="tertiary"
      padding={0}
      minWidth={0}
      height="100%"
      width="100%"
      onClick={onClick}
    >
      {children}
    </Button>
  ) : (
    children
  );

export const PropertyPinIcon = ({
  propertyId,
  color,
  text,
  subjectAsPin = true,
  onClick,
}: PropertyPinIconProps) => (
  <Wrapper onClick={onClick}>
    {propertyId === 'subject' ? (
      <Icon
        icon={subjectAsPin ? 'subject-map-pin-filled' : 'home-heart-filled'}
        size="lg"
        color="textWarning"
      />
    ) : (
      <Box position="relative">
        <Icon icon="map-pin-filled" size="lg" color={color} />
        <Box
          position="absolute"
          top="40%"
          left="50%"
          transform="translate(-50%, -50%)"
          fontSize="xs"
          fontWeight="bold"
          color="white"
          lineHeight="1"
          pointerEvents="none"
        >
          {text}
        </Box>
      </Box>
    )}
  </Wrapper>
);
